module.exports = __webpack_public_path__ + "img/mobile scanner stand22.a0456161.jpg";